// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === "2931") return "2931.b3899dc9e.bundle.js";
if (chunkId === "6633") return "6633.b3899dc9e.bundle.js";
  // return url for filenames based on template
  return "" + chunkId + ".b3899dc9e.chunk.js"
}